export const MAIN_NAV = [
  {
    title: 'Flights',
    icon: 'flighticon.svg',
    iconDark: 'flighticonprimary.svg',
    path: 'flights',
    isDisabled: false,
    type: 'button'
  },
  // {
  //   title: 'Hotel',
  //   icon: 'hotelicon.svg',
  //   iconDark: 'hotwlprimary.svg',
  //   path: 'hotel',
  //   isDisabled: false,
  //   type: 'button'
  // },
  // {
  //   label: 'trains',
  //   icon: 'train.svg',
  //   iconDark: 'trainprimary.svg',
  //   path: '',
  //   type: 'button'
  // },
  // {
  //   label: 'Buses',
  //   icon: 'bus.svg',
  //   iconDark: 'busprimary.svg',
  //   path: '',
  //   type: 'button'
  // },
  // {
  //   title: 'Visa',
  //   icon: 'visaicon.png',
  //   iconDark: 'visaPrimary.png',
  //   path: 'visa',
  //   isDisabled: false,
  //   type: 'button'
  // },
  // {
  //   title: 'Car',
  //   icon: 'car.svg',
  //   iconDark: 'carprimary.svg',
  //   path: '/',
  //   isDisabled: true,
  //   type: 'button'
  // },
];

export const PROFILE_NAV = [
  {
    label: 'My Profile',
    content: 'Manage your profile, login details and  password',
    icon: 'person',
    path: 'profile',
    type: 'button',
    showInCorporate: 'both'
  },
  {
    label: 'My Travellers',
    content: 'Manage traveller details',
    icon: 'group',
    path: 'traveller',
    type: 'button',
    showInCorporate: 'both'
  },
  {
    label: 'My Bookings',
    content: 'See booking details, Print e-ticket, Cancel Booking, Modify Booking, Check Refund Status & more.',
    icon: 'event',
    path: 'my-booking',
    type: 'button',
    showInCorporate: 'both'
  },
  {
    label: 'User Management',
    content: 'Manage user profiles, roles, permissions, and activity in one place.',
    icon: 'manage_accounts',
    path: 'user-management',
    type: 'button',
    showInCorporate: 'corporate'
  },
  {
    label: 'Report Download',
    content: 'Download reports and access key data insights quickly.',
    icon: 'download',
    path: 'report-download',
    type: 'button',
    showInCorporate: 'corporate'
  },
  // {
  //   label: 'My Wallet',
  //   content: 'Use your wallet money to avail even greater discounts',
  //   icon: 'account_balance_wallet',
  //   path: 'wallet',
  //   type: 'button',
  // }
]

export const FOOTER_ABOUT_NAV = [
  {
    label: 'Get to Know Us',
    path: 'about-us',
    type: 'button'
  },
  {
    label: 'Global Presence',
    path: 'global-presence',
    type: 'button'
  },
  {
    label: 'Engagement & Legal',
    path: 'engagement-and-legal',
    type: 'button'
  },
  // {
  //   label: 'Our Team',
  //   path: 'team',
  //   type: 'button'
  // },
  // {
  //   label: 'Online Partners',
  //   path: 'online-partners',
  //   type: 'button'
  // },
  // {
  //   label: 'Visa Refund Policy',
  //   path: 'refund-policy',
  //   type: 'button'
  // },
  // {
  //   label: 'SOTO',
  //   path: 'soto',
  //   type: 'button'
  // },
  // {
  //   label: 'GST',
  //   path: 'gst',
  //   type: 'button'
  // },
  // {
  //   label: 'Affiliations',
  //   path: 'affiliations',
  //   type: 'button'
  // },

]
export const FOOTER_Privacy_Nav = [
  {
    label: 'Terms & Conditions',
    path: 'terms-and-conditions',
    type: 'button'
  },
  {
    label: 'Privacy Policy',
    path: 'privacy-policy',
    type: 'button'
  }
]

export const FOOTER_TRAVEL_HELP_NAV = [
  {
    label: 'Booking Guidelines',
    path: 'booking-guidelines',
    type: 'button'
  },
  // {
  //   label: 'Travel Advisory',
  //   path: 'travel-advisory',
  //   type: 'button'
  // },
  {
    label: 'Visa',
    path: 'visa',
    type: 'button'
  },
  // {
  //   label: 'IATA Agent',
  //   path: 'iata',
  //   type: 'button'
  // },
  // {
  //   label: 'Covid-19 Travel Guidelines',
  //   path: 'covid-guidelines',
  //   type: 'button'
  // },
  // {
  //   label: 'Airports List',
  //   path: 'airport',
  //   type: 'button'
  // },
  // {
  //   label: 'Online Travel Solution',
  //   path: 'travel-solution',
  //   type: 'button'
  // },
  {
    label: 'Online Booking',
    path: 'online-booking',
    type: 'button'
  },
  {
    label: 'Web Check In',
    // path:'web-checkin',
    path: 'web-check-in',
    type: 'button'
  },
  {
    label: 'Flight Booking',
    path: 'flight-booking',
    type: 'button'
  },
  // {
  //   label: 'FAQ Hotels',
  //   path: 'faq-hotels',
  //   type: 'button'
  // },
]
export const FOOTER_QUICK_NAV = [
  // {
  //   label: 'Activities',
  //   path: 'activities',
  //   type: 'button'
  // },
  // {
  //   label: 'Payment',
  //   path: 'payment',
  //   type: 'button'
  // },
  {
    label: 'Great Deals',
    path: 'great-deals',
    type: 'button'
  },
  {
    label: 'Airline Offers',
    path: 'airline-offers',
    type: 'button'
  },
  // {
  //   label: 'Sitemap',
  //   path: 'sitemap',
  //   type: 'button'
  // },
  // {
  //   label: 'Booking Guideline',
  //   path: 'booking-guideline',
  //   type: 'button'
  // },
  {
    label: 'Travel Guide Security',
    path: 'travel-guide-security',
    type: 'button'
  },
  {
    label: 'Airline Web Check-In',
    path: 'airline-web-check-in',
    type: 'button'
  },
  {
    label: 'Amendment Cancellation',
    path: 'amendment-cancellation-policy',
    type: 'button'
  },  
 

  
]
export const FOOTER_TOUCH_NAV = [
  {
    label: 'Contact Us',
    path: 'contact-us',
    type: 'button'
  },
  {
    label: 'FAQs',
    path: 'faqs',
    type: 'button'
  },
  // {
  //   label: 'Career',
  //   path: 'career',
  //   type: 'button'
  // }
]

export const FOOTER_INFORMATION_NAV = [
  // {
  //   label: 'Flight Changes',
  //   path: 'flight-changes',
  //   type: 'button'
  // },
  // {
  //   label: 'Flight Booking',
  //   path: 'flight-booking',
  //   type: 'button'
  // },
  {
    label: 'Domestic Airlines',
    path: 'airlines/domestic',
    type: 'button'
  },
  // {
  //   label: 'International Airlines',
  //   path: 'international-airlines',
  //   type: 'button'
  // },
  // {
  //   label: 'Cancellation & Check Policy',
  //   path: 'cancellation-policy',
  //   type: 'button'
  // },
  { 
    label: 'International Airlines',
    path: 'airlines/international',
    type: 'button'
  },
  { 
    label: 'Domestic Airports',
    path: 'airports/domestic',
    type: 'button'
  },
  { 
    label: 'International Airports',
    path: 'airports/international',
    type: 'button'
  },
  {
    label: 'Search Flights',
    path: 'search-flights',
    type: 'button'
  },
]

export const FOOTER_HOTEL_INFORMATION_NAV = [
  {
    label: 'Hotel',
    path: 'hotels',
    type: 'button'
  },
]

export const FOOTER_VISA_INFORMATION_NAV = [
  {
    label: 'Visa',
    path: 'visas',
    type: 'button'
  },
]

export const FIRST_B2B_NAV = [
  { label: 'About Us', path: 'about-us', type: 'button', },
  { label: 'Airline Partner', path: 'airline-partner', type: 'button', },
  { label: 'Airline Web-checking', path: 'airline-web-checkin', type: 'button', },
  { label: 'Travel Insurance', path: 'travel-insurance', type: 'button', },
  { label: 'Great Deals', path: 'great-deals', type: 'button', },
  { label: 'Management', path: 'management', type: 'button', },
  { label: 'Bank Details', path: 'bank-details', type: 'button', },
]

export const SECOUND_B2B_NAV = [
  { label: 'Visa', path: 'visa', type: 'button', },
  { label: 'Global Network', path: 'global-network', type: 'button', },
  { label: 'Top Airports', path: 'top-airports', type: 'button', },
  { label: 'Escalation', path: 'escalation', type: 'button', },
  { label: 'Contact Us', path: 'contact-us', type: 'button', },
  { label: 'FAQ', path: 'faq', type: 'button', },
]

export const THIRD_B2B_NAV = [ 
  { label: 'Terms and Conditions', path: 'visa', type: 'button', },
  { label: 'Privacy Policy', path: 'global-network', type: 'button', },
  { label: 'Cookie Policy', path: 'top-airports', type: 'button', },
]